<template>
  <div class="flex act-container">
    <div>
      <act-preview
        navigationBg="transparent"
        phoneHeaderFixed
        phoneBodyOverflowHidden
        phoneHeaderFixedColor="#fff"
      >
        <div
          class="slot"
          :style="{ backgroundImage: 'url(' + ruleForm.gameBgp + ')' }"
        >
          <div class="change-bg">
            <div
              class="upload-img pointer"
              v-if="ruleForm.gameBgp"
              @click="toggleShow('bg')"
            >
              更换背景
            </div>
          </div>
          <div class="title-img-wrapper redeem-upload prev-upload" v-if="styleType=='virtualize' || styleType2=='virtualize'">
            <div
              class="upload-img"
              v-if="ruleForm.gameBgp3"
              @click="toggleShow('virtualize')"
            >
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img02" :src="ruleForm.gameBgp3" alt="" />
          </div>
          <div class="title-img-wrapper redeem-upload prev-upload" v-else>
            <div
              class="upload-img"
              v-if="ruleForm.gameBgp2"
              @click="toggleShow"
            >
              <span class="hmicon icon-shangchuantupian1"></span>
            </div>
            <img class="header-img" :src="ruleForm.gameBgp2" alt="" />
          </div>
        </div>
      </act-preview>
    </div>
    <div class="add-goods-container ">
      <div class="act-wrapper">
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="140px"
        >
          <div id="base">1.基本信息</div>
          <el-form-item label="活动标题" prop="gameName">
            <el-input
              style="width: 400px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.gameName"
              placeholder="请输入活动标题"
            ></el-input>
          </el-form-item>
          <el-form-item label="活动时间段选择" prop="activityDate">
            <el-date-picker
              :default-time="['00:00:00', '23:59:59']"
              v-model="ruleForm.activityDate"
              :picker-options="pickerOptions0"
              type="datetimerange"
              align="right"
              start-placeholder="活动开始时间"
              end-placeholder="活动结束时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
              v-if="!type"
            ></el-date-picker>
            <div v-if="type">
              开始时间：
              <el-date-picker
                      :disabled="type === 'details'"
                      v-model="ruleForm.activityDate[0]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="['00:00:00', '23:59:59']"
                      placeholder="开始时间"
                      size="small"
                      class="mr10"
              >
              </el-date-picker>
            </div>
            <div v-if="type">
              结束时间：
              <el-date-picker
                      size="small"
                      :editable="false"
                      v-model="ruleForm.activityDate[1]"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      :default-time="'23:59:59'"
                      placeholder="结束时间"
                      :picker-options="pickerOptions"
              >
              </el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="虚拟开奖时间" prop="autoOpenTime" v-if="styleType=='virtualize' || styleType2=='virtualize'">
            <el-date-picker
              format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.autoOpenTime"
              type="datetime"
              :picker-options="pickerOptions"
              style="width: 400px"
              align="right"
              placeholder="虚拟开奖时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
            <div class="form-tip">
              到达虚拟开奖后不会真实开奖，仅提示用户去其它地方领奖
            </div>
          </el-form-item>
          <el-form-item label="自动开奖时间" prop="autoOpenTime" v-else>
            <el-date-picker
              format="yyyy-MM-dd HH:mm:ss"
              v-model="ruleForm.autoOpenTime"
              type="datetime"
              :picker-options="pickerOptions"
              style="width: 400px"
              align="right"
              placeholder="自动开奖时间"
              value-format="yyyy-MM-dd HH:mm:ss"
              size="small"
              class="mr10"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="活动分享文案" prop="gameShareContent">
            <el-input
              style="width: 400px"
              size="small"
              type="textarea"
              :autosize="{ minRows: 4, maxRows: 7 }"
              placeholder="请输入活动分享文案"
              v-model.trim="ruleForm.gameShareContent"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="活动背景图：" prop="gameBgp">
            <my-upload
              field="file"
              @crop-success="cropSuccess"
              @crop-upload-success="cropUploadSuccess"
              @crop-upload-fail="cropUploadFail"
              v-model="show"
              v-if="show"
              noCircle
              noSquare
              :width="imgwidth"
              :height="imgheight"
              :headers="{ 'X-Access-Token': $token }"
              :params="{ fileDir: 'mallDecoration' }"
              :url="$uploadUrl"
              img-format="png"
            ></my-upload>

            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShow('bg')"
                v-if="!ruleForm.gameBgp"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span class="gray">上传背景图</span>
              </div>

              <div v-if="ruleForm.gameBgp" class="mr10 flex item-end priview">
                <img class="logo" :src="ruleForm.gameBgp" alt="logo" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow('bg')"
                    >更换</el-button
                  >
                </div>
              </div>
              <div class="form-tip flex flex-column flex-end">
                图片尺寸建议750x1334（最多上传一张）
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动标题图：" prop="gameBgp3" v-if="styleType=='virtualize' || styleType2=='virtualize'">
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShow('virtualize')"
                v-if="!ruleForm.gameBgp3"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span class="gray">上传文案图</span>
              </div>

              <div
                v-if="ruleForm.gameBgp3"
                class="mr10 flex item-end priviewheadline priviewheadlineNew"
              >
                <img class="logo" :src="ruleForm.gameBgp3" alt="logo" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow('virtualize')">删除</el-button>
                </div>
              </div>
              <div class="form-tip flex flex-column flex-end">
                图片尺寸建议456x103（最多上传一张）
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动文案图：" prop="gameBgp2">
            <div class="flex upload-upload-btn">
              <div
                class="btn flex flex-column flex-center open-file"
                @click="toggleShow"
                v-if="!ruleForm.gameBgp2"
              >
                <div class="add-wrapper">
                  <span class="hmicon icon-hao pointer"></span>
                </div>
                <span class="gray">上传文案图</span>
              </div>

              <div
                v-if="ruleForm.gameBgp2"
                class="mr10 flex item-end priviewheadline"
              >
                <img class="logo" :src="ruleForm.gameBgp2" alt="logo" />
                <div class="opreat-wrapper flex item-center flex-center">
                  <el-button type="text" @click="toggleShow">删除</el-button>
                </div>
              </div>
              <div class="form-tip flex flex-column flex-end">
                图片尺寸建议750x580（最多上传一张）
              </div>
            </div>
          </el-form-item>
          <el-form-item label="活动规则说明" prop="gameRuleRemark">
            <hm-rich-editor
              v-model="ruleForm.gameRuleRemark"
              :html="ruleForm.gameRuleRemark"
            />
          </el-form-item>
          <el-form-item label="中奖人数" prop="winnerNum">
            <el-input
              type="number"
              maxlength="30"
              @mousewheel.prevent.native
              style="width: 300px"
              size="small"
              clearable
              class="mr10 ipt"
              v-model.trim="ruleForm.winnerNum"
              placeholder="请输入中奖人数"
            ></el-input
            >人
            <div class="form-tip">
              中奖人数只能填大于0的正整数
            </div>
          </el-form-item>
          <el-form-item
            label="自主报名是否默认为中奖候选人"
            prop="isDefaultWinner"
          >
            <el-switch
              v-model="ruleForm.isDefaultWinner"
              size="mini"
              active-color="#13ce66"
              inactive-color="#97a8be"
              active-value="yes"
              active-text="是"
              inactive-text="否"
              inactive-value="no"
            >
            </el-switch>
          </el-form-item>
          <div v-if="styleType == 'virtualize' || styleType2 == 'virtualize'">
            <div id="base">2活动拓展规则</div>
            <el-form-item label="开奖门槛" prop="rewardValue">
              <div>
                总达到
                <el-input
                  type="number"
                  maxlength="10"
                  @mousewheel.prevent.native
                  style="width: 150px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  @input="filterGt0('rewardValue')"
                  v-model.trim="ruleForm.rewardValue"
                  placeholder="请输入开奖门槛"
                ></el-input
                >个助力值后开奖
              </div>
              <div class="form-tip">
                必须达到活动助力值门槛才能开奖，手动开奖自动补齐未达标助力值
              </div>
              <div>
                手动增加助力值
                <el-input
                  type="number"
                  maxlength="10"
                  @mousewheel.prevent.native
                  style="width: 150px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  @input="filterGt('addValue')"
                  v-model.trim="ruleForm.addValue"
                  placeholder="请输入助力值"
                ></el-input
                >
                <span v-if="(parseInt(ruleForm.addValue) + parseInt(ruleForm.totalHelpValue)) > 0">当前总助力{{parseInt(ruleForm.addValue) + parseInt(ruleForm.totalHelpValue)}}</span>
              </div>
            </el-form-item>
            <el-form-item label="助力值别名" prop="aliasName">
              <el-input
                type="text"
                maxlength="6"
                @mousewheel.prevent.native
                style="width: 150px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.aliasName"
                placeholder="请输入助力值别名"
              ></el-input>
            </el-form-item>
            <el-form-item label="个人获得助力值途径" prop="shareValue">
              <div>
                分享好友后获得
                <el-input
                  type="number"
                  maxlength="10"
                  @mousewheel.prevent.native
                  style="width: 150px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  @input="filterGt0('shareValue')"
                  v-model.trim="ruleForm.shareValue"
                  placeholder="请输入助力值"
                ></el-input
                >个助力值，每日上限
                <el-input
                  type="number"
                  maxlength="10"
                  @mousewheel.prevent.native
                  style="width: 150px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  @input="filterGt0('shareTotal')"
                  v-model.trim="ruleForm.shareTotal"
                  placeholder="请输入助力值"
                ></el-input
                >个助力值
              </div>
              <div class="form-tip">
                被分享的好友必须进入页面并参与才能助力成功，每个好友1个活动仅能助力1次
              </div>
              <div>
                每日签到后获得
                <el-input
                  type="number"
                  maxlength="10"
                  @mousewheel.prevent.native
                  style="width: 150px"
                  size="small"
                  clearable
                  class="mr10 ipt"
                  @input="filterGt0('signValue')"
                  v-model.trim="ruleForm.signValue"
                  placeholder="请输入助力值"
                ></el-input
                >个助力值
              </div>
            </el-form-item>
          </div>
        </el-form>
        <div class="flex flex-center mt10">
          <el-button
            type="primary"
            size="small"
            @click="submitForm('ruleForm')"
            >发布</el-button
          >
          <el-button size="small" @click="$router.back(-1)">返回</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import myUpload from "vue-image-crop-upload";
import HmRichEditor from "@/components/HmRichEditor";
import actPreview from "@/components/actPreview";
import { mapGetters } from "vuex";
export default {
  components: { myUpload, HmRichEditor, actPreview },
  data() {
    const rewardValueFunc = function(rule, val, callback) {
      
      if (!this.ruleForm.rewardValue) {
        return callback(new Error("请输入开奖门槛"));
      }

      if (!this.ruleForm.addValue) {
        return callback(new Error("请输入手动增加助力值"));
      }

      callback();
    }.bind(this);
    const shareValueFunc = function(rule, val, callback) {
      
      if (!this.ruleForm.shareValue) {
        return callback(new Error("请输入分享好友获得的助力值"));
      }

      if (!this.ruleForm.shareTotal) {
        return callback(new Error("请输入每日上限的助力值"));
      }

      if (!this.ruleForm.signValue) {
        return callback(new Error("请输入每日签到的助力值"));
      }

      callback();
    }.bind(this);
    return {
      styleType:"",
      styleType2:"",
      imgwidth: 0,
      imgheight: 0,
      show: false,
      type: this.$route.query.type,
      gameId: this.$route.query.gameId,
      uploadType: "",
      pickerOptions: {
        disabledDate: this.disabledDates
      },
      pickerOptions0: {
        disabledDate(time) {
          let curDate = new Date().getTime();
          // 这里算出一个月的毫秒数,这里使用30的平均值,实际中应根据具体的每个月有多少天计算
          let day = 365 * 24 * 3600 * 1000;
          let dateRegion = curDate + day;
          return (
            time.getTime() < Date.now() - 8.64e7 || time.getTime() > dateRegion
          );
        }
      },
      ruleForm: {
        activityDate: "",
        autoOpenTime: "",
        gameName: "",
        gameRuleRemark: "",
        gameShareContent: "",
        gameBgp:
          "https://imgcdn.hemiao100.com/mall/ps9979bd3deb8a1e9f-1bd3-4e12-b8fe-bf730c819383.png",
        gameBgp2:
          "https://imgcdn.hemiao100.com/mall/ps0408f174396e1ce1-2072-46e5-b50f-997e1a319920.png",
        gameBgp3:
          "https://imgcdn.hemiao100.com/hemiaoBase/luckyOne/title.png",  
        winnerNum: "",
        isDefaultWinner: "no",
        rewardValue: "",
        addValue: "",
        aliasName: "",
        shareValue: "",
        shareTotal: "",
        signValue: "",
        totalHelpValue: 0,
      },
      rules: {
        gameName: [
          {
            required: true,
            message: "请输入活动标题",
            trigger: "blur"
          },
          { min: 2, max: 30, message: "长度在 2 到 30 个字符", trigger: "blur" }
        ],
        activityDate: {
          required: true,
          message: "请输入活动时间",
          trigger: "blur"
        },
        autoOpenTime: {
          required: true,
          message: "请输入开奖时间",
          trigger: "blur"
        },
        gameShareContent: [
          {
            required: true,
            message: "请输入活动分享文案",
            trigger: "blur"
          }
        ],
        gameBgp: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        gameRuleRemark: [
          {
            required: true,
            message: "请输入活动规则说明",
            trigger: "blur"
          }
        ],
        gameBgp2: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        gameBgp3: {
          required: true,
          message: "请上传图片",
          trigger: "blur"
        },
        winnerNum: [
          {
            required: true,
            message: "请输入中奖人数",
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        isDefaultWinner: {
          required: true,
          message: "自主报名是否默认为中奖候选人",
          trigger: "blur"
        },
        rewardValue:[
          {
            required: true,
            trigger: "blur",
            validator: rewardValueFunc,
          },
        ],
        aliasName: {
          required: true,
          message: "请输入助力值别名",
          trigger: "blur"
        },
        shareValue:[
          {
            required: true,
            trigger: "blur",
            validator: shareValueFunc,
          },
        ],
      },
      updateMode: "",
      gameBgpNew: "https://imgcdn.hemiao100.com/hemiaoBase/luckyOne/bg.png",
      gameBgpNew2: "https://imgcdn.hemiao100.com/hemiaoBase/luckyOne/title.png",
    };
  },
  computed: mapGetters(["storeStyle"]),
  watch: {},
  created() {
    this.styleType = this.$route.query.styleType;
  },
  mounted() {
    if (this.type) {
      this.queryDetails();
    }else{
      if(this.styleType==="virtualize"){
        this.ruleForm.gameBgp = this.gameBgpNew;
        this.ruleForm.gameBgp3 = this.gameBgpNew2;
      }
    }
    this.$store.dispatch("queryStoreStyle");
  },
  methods: {
    disabledDates(time) {
      let limtTiem = this.ruleForm.activityDate[1];
      return time.getTime() < new Date(limtTiem).getTime() - 8.64e7;
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: this.gameId
      });
      for (let key in this.ruleForm) {
        this.ruleForm[key] = result[key];
      }
      this.ruleForm.autoOpenTime = result.luckyCharmRuleModel.autoOpenTime;
      this.ruleForm.winnerNum = result.luckyCharmRuleModel.winnerNum;
      this.ruleForm.rewardValue = result.luckyCharmRuleModel.rewardValue;
      this.ruleForm.addValue = result.luckyCharmRuleModel.addValue;
      this.ruleForm.aliasName = result.luckyCharmRuleModel.aliasName;
      this.ruleForm.shareValue = result.luckyCharmRuleModel.shareValue;
      this.ruleForm.shareTotal = result.luckyCharmRuleModel.shareTotal;
      this.ruleForm.signValue = result.luckyCharmRuleModel.signValue;
      if(this.$route.query.type === "copy"){
        this.ruleForm.totalHelpValue = 0;
      }else{
        this.ruleForm.totalHelpValue = result.luckyCharmRuleModel.totalHelpValue;
      }
      this.styleType2 = result.luckyCharmRuleModel.styleType;
      this.ruleForm.isDefaultWinner =
        result.luckyCharmRuleModel.isDefaultWinner;
      this.ruleForm.activityDate = [result.gameStartTime, result.gameEndTime];

      this.updateMode = result.updateMode;
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.ruleForm));
          // params.gameBgp2  = "https://imgcdn.hemiao100.com/mall/ps0408f174396e1ce1-2072-46e5-b50f-997e1a319920.png";
          params.luckyCharmRuleModel = {
            autoOpenTime: params.autoOpenTime,
            winnerNum: params.winnerNum,
            isDefaultWinner: params.isDefaultWinner,
            styleType: this.$route.query.styleType || this.styleType2,
            rewardValue: params.rewardValue,
            addValue: params.addValue,
            aliasName: params.aliasName,
            shareValue: params.shareValue,
            shareTotal: params.shareTotal,
            signValue: params.signValue,
          };
          params.gameStartTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[0]
              : "";
          params.gameEndTime =
            this.ruleForm.activityDate && this.ruleForm.activityDate.length > 0
              ? this.ruleForm.activityDate[1]
              : "";
          params.gameType = "lucky_charm";
          let name = this.type == "details" ? "editActivity" : "addTurntable";
          params.gameId = this.gameId;
          params.updateMode = this.updateMode;
          params.isLook = 'yes';
          console.log("params:",params);
          if (this.type === "edit") {
            this.$store.dispatch("editGameInfoJieLong", params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          } else {
            this.$store.dispatch(name, params).then(res => {
              if (res.code === "0") {
                this.$message({
                  message: "操作成功",
                  type: "success"
                });
                this.$router.back(-1);
              }
            });
          }

        } else {
          return false;
        }
      });
    },
    handleRemove(type) {
      if (type === "bg") {
        this.ruleForm.gameBgp = "";
      } else if(type === 'virtualize') {
        this.ruleForm.gameBgp3 = "";
      } else {
        this.ruleForm.gameBgp2 = "";
      }
    },
    toggleShow(type) {
      this.uploadType = type;
      if (type === "bg") {
        this.imgwidth = 750;
        this.imgheight = 1334;
      } else if(type === 'virtualize') {
        this.imgwidth = 456;
        this.imgheight = 103;
      } else{
        this.imgwidth = 750;
        this.imgheight = 580;
      }
      this.show = !this.show;
    },
    cropSuccess() {},
    cropUploadFail() {},
    cropUploadSuccess(jsonData) {
      if (this.show) {
        if (this.uploadType === "bg") {
          this.ruleForm.gameBgp = jsonData.result;
        } else if(this.uploadType=== 'virtualize') {
          this.ruleForm.gameBgp3 = jsonData.result;
        } else {
          this.ruleForm.gameBgp2 = jsonData.result;
        }
      }
    },
    filterGt(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
    filterGt0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");
    },
  }
};
</script>
<style lang="scss" scoped>
.upload-upload-btn {
  .tips {
    color: #999;
    font-size: 12px;
    line-height: 20px;
  }

  .btn {
    border-radius: 6px;
    border: 1px solid #ddd;
    text-align: center;
    padding: 10px;
    margin-right: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
    .add-wrapper {
      width: 30px;
      height: 30px;
      line-height: 30px;
      background: #e50065;
      color: #fff;
      text-align: center;
      border-radius: 50%;
      margin: 0 auto;
      span {
        font-size: 12px;
      }
      cursor: pointer;
      .hmicon {
        font-size: 14px;
      }
    }
  }
}
.priviewheadline {
  position: relative;
  width: 300px;
  height: 200px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}
.priviewheadlineNew{
  width: 228px;
  height: 52px;
}
.priview {
  position: relative;
  width: 300px;
  height: 500px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  img {
    width: 100%;
    height: 100%;
  }
  .opreat-wrapper {
    transition: opacity 0.2s linear;
    position: absolute;
    opacity: 0;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 6px;
  }

  .slot {
    position: relative;
  }

  &:hover {
    .opreat-wrapper {
      opacity: 1;
    }
  }
}

.act-container {
  max-width: 2000px;
  overflow-x: auto;
  .step-wrapper {
    border-bottom: none !important;
    margin-bottom: 0;
  }
  .add-goods-container {
    width: 1128px;
    flex-shrink: 0;
  }
  .phone-body {
    overflow: hidden !important;
  }
  .slot {
    position: relative;
    background-size: 100% 100%;
    height: 100%;
    &:hover {
      .change-bg {
        display: block;
      }
    }
    .upload-img {
      top: 60px;
    }
    .header-img-wrapper {
      box-sizing: border-box;
      .header-img {
        width: 100%;
        display: block;
      }      
    }
    .change-bg {
      position: absolute;
      top: 60px;
      right: 0;
      height: 34px;
      font-size: 12px;
      background-color: rgba(0, 0, 0, 0.8);
      border: 1px solid #fff;
      border-radius: 4px;
      text-align: center;
      line-height: 34px;
      color: #fff;
      z-index: 10;
      padding: 0 10px;
      display: none;
    }
    .empty {
      margin-top: 30px;
      text-align: center;
    }
    .title-img-wrapper {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
    }
  }
}
.header-img02{
  width: 228px;
  height: 52px;
  display: block;
  position: absolute;
  left: 50%;
  top: 77px;
  transform: translateX(-50%);
}
</style>
